// extracted by mini-css-extract-plugin
export default {"container":"QRcode_container__-EuA8","botButton":"QRcode_botButton__OiMP9","backLink":"QRcode_backLink__dLs7Z"};